<template>
<app-layout>
    <template #header>
        <FarmTitle>
            Ställe
        </FarmTitle>
    </template>

    <div class="py-12">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                <!-- This example requires Tailwind CSS v2.0+ -->
                <div class="bg-white shadow overflow-hidden sm:rounded-md">
                    <ul class="divide-y divide-gray-200">
                        <li v-for="farm in farms">
                            <inertia-link :href="route('farm.stables', {farm: farm})" class="block hover:bg-gray-50">
                                <div class="px-4 py-4 flex items-center sm:px-6">
                                    <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                                        <div class="truncate">
                                            <div class="flex text-sm">
                                                <p class="font-medium text-indigo-600 truncate">{{ farm.name }}</p>
                                                <p class="ml-1 flex-shrink-0 font-normal text-gray-500">
                                                    ({{ farm.stable_count }} {{ farm.stable_count!=1 ? "Ställe" : "Stall" }})
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ml-5 flex-shrink-0">
                                        <ChevronRightIcon class="w-6 h-6 text-gray-400" />
                                    </div>
                                </div>
                            </inertia-link>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import FarmTitle from "@/Layouts/FarmTitle";
import { ChevronRightIcon } from "@heroicons/vue/solid";
export default {
    name: "Index",
    components: {FarmTitle, AppLayout, ChevronRightIcon},
    props: ['farms']
}
</script>

<style scoped>

</style>
